import {OrganizationUnit, OrganizationUnitRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {useApiManager} from "../../../../components/utils/api";
import {TableCell} from "@mui/material";

export const OrganizationUnitListPage = () => {
	const apiManager = useApiManager();

	const listConfig: AppListConfig<OrganizationUnit> = {
		title: "Unidades organizativas",
		onClick: "/app/admin/employee/organizationunit",
		headers: [
			{title: "Nombre"},
			{title: "Unidad superior"},
			{title: "Responsable"},
		],
		decorator: (bean: OrganizationUnit) => (
			<>
				<TableCell>
					{bean.name}
				</TableCell>
				<TableCell>
					{bean.parent?.name}
				</TableCell>
				<TableCell>
					{bean.manager?.surnamesAndName}
				</TableCell>
			</>
		),
		supplier: async (currentPage, size, term, showDismissed) => {
			const ctrl = apiManager.factory(OrganizationUnitRestControllerApiFactory);
			return ctrl.pageOrganizationUnit(
				currentPage,
				size,
				undefined,
				term,
				showDismissed
			);
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};